<ui-page-container>
  <ng-container *ngIf="(systemInfo$ | async)?.entityCounts as entityCounts">
    <ng-container *roleVisibility="['read', 'read+all']; classNames: ['BeneOA', 'BeneF', 'BeneMI', 'BeneD', 'BeneS', 'Base']">
      <h2>{{ 'Beni' | translate }}</h2>
      <div class="info-container">
        <app-card-info
          *roleVisibility="['read', 'read+all']; classNames: ['BeneOA']"
          [value]="entityCounts?.BeneOA || 0"
          [label]="'Oggetti artistici' | translate"
          [routerLink]="['/cards']"
          [queryParams]="{ card: 0 }">
        </app-card-info>
        <app-card-info
          *roleVisibility="['read', 'read+all']; classNames: ['BeneF']"
          [value]="entityCounts?.BeneF || 0"
          [label]="'Fotografie' | translate"
          [routerLink]="['/cards']"
          [queryParams]="{ card: 2 }">
        </app-card-info>
        <app-card-info
          *roleVisibility="['read', 'read+all']; classNames: ['BeneMI']"
          [value]="entityCounts?.BeneMI || 0"
          [label]="'Matrici incise' | translate"
          [routerLink]="['/cards']"
          [queryParams]="{ card: 3 }">
        </app-card-info>
        <app-card-info
          *roleVisibility="['read', 'read+all']; classNames: ['BeneD']"
          [value]="entityCounts?.BeneD || 0"
          [label]="'Disegni' | translate"
          [routerLink]="['/cards']"
          [queryParams]="{ card: 4 }">
        </app-card-info>
        <app-card-info
          *roleVisibility="['read', 'read+all']; classNames: ['BeneS']"
          [value]="entityCounts?.BeneS || 0"
          [label]="'Stampe' | translate"
          [routerLink]="['/cards']"
          [queryParams]="{ card: 1 }">
        </app-card-info>
        <app-card-info
          *roleVisibility="['read', 'read+all']; classNames: ['Base']"
          [value]="entityCounts?.Base || 0"
          [label]="'Basi' | translate"
          [routerLink]="['/base']">
        </app-card-info>
      </div>
    </ng-container>

    <ng-container *roleVisibility="['read', 'read+all']; classNames: ['Collezione']">
      <mat-divider></mat-divider>

      <h2>{{ 'Collezioni' | translate }}</h2>
      <div class="info-container">
        <app-card-info
          *roleVisibility="['read', 'read+all']; classNames: ['Collezione']"
          [value]="entityCounts?.Collezione"
          [label]="'Collezioni' | translate"
          [routerLink]="['/collections']">
        </app-card-info>
      </div>
    </ng-container>


    <ng-container *roleVisibility="['read', 'read+all']; classNames: ['DocumentoBib', 'DocumentoArc']">
      <mat-divider></mat-divider>

      <h2>{{ 'Documenti' | translate }}</h2>
      <div class="info-container">
        <app-card-info
          *roleVisibility="['read', 'read+all']; classNames: ['DocumentoBib']"
          [value]="entityCounts?.DocumentoBib"
          [label]="'Documenti bibliografici' | translate"
          [routerLink]="['/bibs-sources']">
        </app-card-info>
        <app-card-info
          *roleVisibility="['read', 'read+all']; classNames: ['DocumentoArc']"
          [value]="entityCounts?.DocumentoArc"
          [label]="'Documenti archivistici' | translate"
          [routerLink]="['/archival-sources']">
        </app-card-info>
      </div>
    </ng-container>


    <ng-container *ngIf="isAdmin$ | async">
      <mat-divider></mat-divider>

      <h2>{{ 'Sistema' | translate }}</h2>
      <div class="info-container">
        <app-card-info
          [value]="entityCounts?.File"
          [label]="'Media' | translate"
          [routerLink]="['/media']">
        </app-card-info>
        <app-card-info
          [value]="entityCounts?.User"
          [label]="'Utenti' | translate"
          [routerLink]="['/users']">
        </app-card-info>
        <app-card-info
          [value]="entityCounts?.Role"
          [label]="'Ruoli' | translate"
          [routerLink]="['/roles']">
        </app-card-info>
        <app-card-info
          [value]="entityCounts?.Capability"
          [label]="'Capabilities' | translate"
          [routerLink]="['/roles']">
        </app-card-info>
        <app-card-info
          [value]="entityCounts?.Session"
          [label]="'Sessioni' | translate"
          [routerLink]="['/audits']">
        </app-card-info>
      </div>
    </ng-container>
  </ng-container>
</ui-page-container>

